<template>
    <div id="reviews">
        <div v-if="loading">
            <device-details-reviews-skeleton />
        </div>
        <template v-else>
            <div class="d-flex flex-row justify-content-between">
                <div class="pb-1 lead fw-bold">
                    <div v-if="reviewsTotalNumber > 0">
                        {{ reviewsOffsetMessage }}
                    </div>
                    <div v-else>
                        {{ reviewsMessages.noResultReviewsMessage }}
                    </div>
                </div>
                <div class="d-md-none">
                    <ob1-liens-icone
                        is-button
                        :mini="true"
                        modal-id="slide-filters-reviews-modal"
                        title="Filtrer"
                        class="noDefaultStyleButton"
                        data-bs-toggle="modal"
                        icon="icon-filter"
                        type="button"
                    />
                </div>
            </div>
            <reviews-details
                v-if="reviewsTotalNumber > 0"
                :device-reviews="deviceReviews"
                :reviews-total-number="reviewsTotalNumber"
                :verified="reviewsMessages.verified"
                :offset="offset"
                :bloc-size="blocSize"
            />
        </template>
    </div>
</template>

<script>
import ReviewsDetails from "./ReviewsDetails.vue";
import DeviceDetailsReviewsSkeleton from "./DeviceDetailsReviewsSkeleton.vue";

export default {
    name: "DeviceDetailsReviews",
    components: {DeviceDetailsReviewsSkeleton, ReviewsDetails},
    props: {
        reviewsTotalNumber: {
            type: Number,
            required: true
        },
        deviceReviews: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        offset: {
            type: Number,
            required: true
        },
        blocSize: {
            type: Number,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
    },
    computed: {
        reviewsOffsetMessage() {
            return `${this.offset + 1}-${Math.min(this.offset + this.blocSize, this.reviewsTotalNumber)} sur ${this.reviewsTotalNumber} ${this.reviewsMessages.message}`;
        },
    }
}
</script>
